import { KYMW1312Component } from './kymw1312.component';
import { isArray } from 'util';
import { PlessViewUtilsSub } from '../../../../../src/app/commons/kymw00/pless-view-utils-sub.service';
import { KYMW1312SetPlanPromotionGoodsInfoModel } from './vo/kymw1312-set-plan-promotion-goods-info.model';
import * as wjcCore from '@grapecity/wijmo';

/**
 * セット企画設定画面の値を管理するクラス
 *
 * @export KYMW1312Model
 * @class KYMW1312Model
 */
export class KYMW1312Model {

  KYMW1312Component: KYMW1312Component;

  private readonly FLAG_ON: string = '1';
  private readonly DIV_BUNDLE: string = 'B';
  private readonly DIV_MIX: string = 'P';
  private readonly DIV_POINT: string = 'T';

  public readonly DIV_UNABLE: any = { label: '0：不可', data: '0' };
  public readonly DIV_ABLE: any = { label: '1：可能', data: '1' };
  public readonly DIV_ABILITY_ARRAY: Array<any> = [this.DIV_UNABLE, this.DIV_ABLE];

  public readonly SET_PLAN_DIV_PARENT: any = { label: '1：親', data: '1' };
  public readonly SET_PLAN_DIV_CHILD: any = { label: '2：子', data: '2' };
  public readonly SET_PLAN_DIV_ARRAY: Array<any> = [this.SET_PLAN_DIV_PARENT, this.SET_PLAN_DIV_CHILD];

  public readonly INIT_APPROVED_NUM: string = '1';		// セット企画数量初期値


  // プロモーションＮＯリスト
  public promotionNoList: Array<any> = null;

  // プロモーションＮＯ
  public promotionNo: string = <string>'';

  // プロモーション名称
  public promotionName: string = <string>'';

  // プロモーション区分
  public promotionDiv: string = <string>'';

  // 設定単位
  public setUnit: string = <string>'';

  // 生協選択　いばらき
  public coopIB: boolean = <boolean>false;

  // 生協選択　とちぎ
  public coopTO: boolean = <boolean>false;

  // 生協選択　ぐんま
  public coopGU: boolean = <boolean>false;

  // 生協選択　ちば
  public coopTI: boolean = <boolean>false;

  // 生協選択　さいたま
  public coopSA: boolean = <boolean>false;

  // 生協選択　とうきょう
  public coopTK: boolean = <boolean>false;

  // 生協選択　ながの
  public coopNA: boolean = <boolean>false;

  // 生協選択　にいがた
  public coopNI: boolean = <boolean>false;

  // 生協選択　クルコ
  public coopKU: boolean = <boolean>false;

  // セット企画数量
  public approvedNum: string = <string>'1';

  // 成立価格
  public approvedPrice: string = <string>'';

  // プロモーション情報
  public promotionInfo: Array<any> = new Array<any>();

  // セット企画区分リスト
  public setPlanDivList: Array<any> = new Array<any>();

  // 単品注文可否区分コードリスト
  public singleOrderFlagList: Array<any> = new Array<any>();

  // 親から子へ自動的に変更された行
  public parentToChildRow: number = <number>0;

  // 編集ロック
  public editLock = false;

  public editLockBtn = false;

  public listLockFlg = false;		// Lock on: true, lock off: false

  // 受注コード
  public orderCode: string = <string>'';

  // 媒体区分
  public mediumType: string = <string>'';

  // 親画面の媒体グループ区分が通常媒体か
  public isGroupNormal = false;

  // 検索時セット企画商品名
  public accessSetDelivGoodsName: string = <string>'';

  // 検索時プロモーション名称
  public accessPromotionName: string = <string>'';

  // 検索時生協コード
  public accessCoopCode: string = <string>'';

  // 検索時Ｐコード
  public accessPCode: string = <string>'';

  // 検索時部門コード
  public accessClassCode: string = <string>'';

  // 編集可否 プロモーション名称
  public disabledPromotionName: boolean = <boolean>false;

  // 編集可否 行削除
  public disabledDelRow: boolean = <boolean>false;

  // 編集可否 全削除
  public disabledDelAll: boolean = <boolean>false;

  // 編集可否 設定
  public disabledRegist: boolean = <boolean>false;

  // 編集可否 設定単位 全生協
  public disabledUnitAll: boolean = <boolean>false;

  // 編集可否 設定単位 生協単位
  public disabledUnitCoop: boolean = <boolean>false;

  // 編集可否 生協 いばらき
  public disabledCoopIB: boolean = <boolean>false;

  // 編集可否 生協 とちぎ
  public disabledCoopTO: boolean = <boolean>false;

  // 編集可否 生協 ぐんま
  public disabledCoopGU: boolean = <boolean>false;

  // 編集可否 生協 ちば
  public disabledCoopTI: boolean = <boolean>false;

  // 編集可否 生協 さいたま
  public disabledCoopSA: boolean = <boolean>false;

  // 編集可否 生協 とうきょう
  public disabledCoopTK: boolean = <boolean>false;

  // 編集可否 生協 ながの
  public disabledCoopNA: boolean = <boolean>false;

  // 編集可否 生協 にいがた
  public disabledCoopNI: boolean = <boolean>false;

  // 編集可否 生協 クルコ
  public disabledCoopKU: boolean = <boolean>false;

  // 編集可否 一括反映
  public disabledReflection: boolean = <boolean>false;

  // 編集可否 セット企画数量
  public disabledApprovedNum: boolean = <boolean>false;

  // 編集可否 成立価格
  public disabledApprovedPrice: boolean = <boolean>false;

  // ソート情報
  public sortDirection: any = null;

  /**
   * サーバから取得したプロモーションＮＯを反映する
   *
   * @param serverData サーバ取得データ
   */
  public updatePromotionNo(serverData: any): void {

    this.promotionNoList = new Array<any>();
    this.promotionNoList.push('');
    this.promotionNo = '';
    
    if (serverData.PromotionNoList != null) {
      if (isArray(serverData.PromotionNoList)) {
        for (let i: number = <number>0; i < serverData.PromotionNoList.length; i++) {
          this.promotionNoList.push(serverData.PromotionNoList[i].PromotionNo);
        }
      } else {
        this.promotionNoList.push(serverData.PromotionNoList.PromotionNo);
      }
    }

    // セット企画区分コードリスト
    this.setPlanDivList = new Array<any>();

    if (isArray(serverData.SetPlanDivList)) {
      for (let i: number = <number>0; i < serverData.SetPlanDivList.length; i++) {
        this.setPlanDivList.push(this.editCodeMasterListItem(serverData.SetPlanDivList[i]));
      }
    } else {
      this.setPlanDivList.push(this.editCodeMasterListItem(serverData.SetPlanDivList));
    }

    // 単品注文可否区分コードリスト
    this.singleOrderFlagList = new Array<any>();

    if (isArray(serverData.SingleOrderFlagList)) {
      for (let i: number = <number>0; i < serverData.SingleOrderFlagList.length; i++) {
        this.singleOrderFlagList.push(this.editCodeMasterListItem(serverData.SingleOrderFlagList[i]));
      }
    } else {
      this.singleOrderFlagList.push(this.editCodeMasterListItem(serverData.SingleOrderFlagList));
    }

    // 価格パターン連動マーク一覧更新
    this.KYMW1312Component.updateSetPlanPromotionGoodsInfo();
  }

  /**
   * コードマスタリスト項目編集
   *
   * @private
   * @param {*} item
   * @returns {object}
   * @memberof KYMW1312Model
   */
  private editCodeMasterListItem(item: any): object {
    return { label: item.CodeValue + '：' + item.CodeName, data: item.CodeValue };
  }

  /**
   * サーバから取得したプロモーション情報を反映する
   *
   * @param serverData サーバ取得データ
   */
  public updateSetPlanPromotionInfo(serverData: any): void {
    this.promotionInfo = new Array<any>();

    if (serverData === null) {
      return; 
    }

    let promotionGoodsInfo: Array<any> = new Array<any>();

    if (isArray(serverData)) {
      promotionGoodsInfo = serverData;
    } else {
      promotionGoodsInfo.push(serverData);
    }

    // プロモーション名
    this.promotionName = PlessViewUtilsSub.nullToBlank(promotionGoodsInfo[0].PromotionName);
    // プロモーション区分
    this.promotionDiv = promotionGoodsInfo[0].PromotionDiv;

    this.listLockFlg = false;

    for (const promotionGoodsData of promotionGoodsInfo) {
      this.promotionInfo.push(this.getSetPlanPromotionGoodsInfoVO(promotionGoodsData));

      // 排他ロック
      if (this.editLockBtn) {
        this.KYMW1312Component.LockUtilForPlanGoods('REGIST',
          this.orderCode,
          promotionGoodsData.MediumType,
          promotionGoodsData.PCode,
          (event: any) => {
            this.KYMW1312Component.listLockScc_Handler(event); 
          },
          null,
          (event: any, result: any): void => {
            this.KYMW1312Component.listLockErr_Handler({ event, result }); 
          },
          null,
          false);
      }
    }
  }

  /* プロモーション情報一覧を作成 */
  private getSetPlanPromotionGoodsInfoVO(data: any): KYMW1312SetPlanPromotionGoodsInfoModel {

    const vo: KYMW1312SetPlanPromotionGoodsInfoModel = new KYMW1312SetPlanPromotionGoodsInfoModel();

    // Ｐコード
    vo.pCode = data.PCode;
    // 媒体区分
    vo.mediumType = data.MediumType;
    // 商品案内用商品名
    vo.guideGoodsName = data.GuideGoodsName;
    // 商品案内用規格名
    vo.guideStandardName = data.GuideStandardName;
    // 消費税区分
    vo.consumeTaxDiv = data.ConsumeTaxDiv;
    // 消費税率
    vo.consumeTaxRate = data.ConsumeTaxRate;

    // 処理区分が2(追加)の場合
    if (data.AccessDiv != null && data.AccessDiv === '2') {
      // 企画商品基本マスタテーブルの値を格納
      // セット企画商品名
      vo.setDelivGoodsName = PlessViewUtilsSub.nullToBlank(data.DeliveryGoodsNameKanji);
      // セット企画商品名（カナ）
      vo.setDelivGoodsNameKana = PlessViewUtilsSub.nullToBlank(data.DeliveryGoodsNameKana);
      // セット企画規格名
      vo.setDelivStandardName = PlessViewUtilsSub.nullToBlank(data.DeliveryStandardNameKanji);
      // セット企画規格名（カナ）
      vo.setDelivStandardNameKana = PlessViewUtilsSub.nullToBlank(data.DeliveryStandardNameKana);
    } else {
      // セット企画プロモーション商品テーブルの値を格納
      // セット企画商品名
      vo.setDelivGoodsName = PlessViewUtilsSub.nullToBlank(data.SetDelivGoodsName);
      // セット企画商品名（カナ）
      vo.setDelivGoodsNameKana = PlessViewUtilsSub.nullToBlank(data.SetDelivGoodsNameKana);
      // セット企画規格名
      vo.setDelivStandardName = PlessViewUtilsSub.nullToBlank(data.SetDelivStandardName);
      // セット企画規格名（カナ）
      vo.setDelivStandardNameKana = PlessViewUtilsSub.nullToBlank(data.SetDelivStandardNameKana);
    }

    // お届け明細用商品名（漢字）
    vo.deliveryGoodsNameKanji = PlessViewUtilsSub.nullToBlank(data.DeliveryGoodsNameKanji);
    // お届け明細用商品名（カナ）
    vo.deliveryGoodsNameKana = PlessViewUtilsSub.nullToBlank(data.DeliveryGoodsNameKana);
    // お届け明細用規格名（漢字）
    vo.deliveryStandardNameKanji = PlessViewUtilsSub.nullToBlank(data.DeliveryStandardNameKanji);
    // お届け明細用規格名（カナ）
    vo.deliveryStandardNameKana = PlessViewUtilsSub.nullToBlank(data.DeliveryStandardNameKana);

    // セット企画区分
    if (this.getDataValue(data.SetPlanDiv) == null) {
      // セット企画区分
      vo.setPlanDiv = this.SET_PLAN_DIV_CHILD.data;
      vo.setPlanDivOrg = vo.setPlanDiv;
      // セット企画区分名称
      vo.setPlanDivName = this.SET_PLAN_DIV_CHILD.label;
      // 単品注文可否区分
      vo.singleOrderFlag = this.DIV_ABLE.data;
      // 単品注文可否区分名称
      vo.singleOrderFlagName = this.DIV_ABLE.label;
      // 注文受付可否区分「0：不可」
      vo.acceptDiv = this.DIV_UNABLE.data;
      // 供給可能区分「1：可能」
      vo.supplyDiv = this.DIV_ABLE.data;
    } else {
      // セット企画区分
      vo.setPlanDiv = data.SetPlanDiv;
      vo.setPlanDivOrg = vo.setPlanDiv;
      // セット企画区分名称
      vo.setPlanDivName = data.SetPlanDivName;
      // 単品注文可否区分
      vo.singleOrderFlag = data.SingleOrderFlag;
      // 単品注文可否区分名称
      vo.singleOrderFlagName = data.SingleOrderFlagName;
      // 注文受付可否区分
      vo.acceptDiv = data.AcceptDiv;
      // 供給可能区分
      vo.supplyDiv = data.SupplyDiv;
    }

    // 取扱フラグ（いばらき）
    if (data.HandlingFlgIB === this.FLAG_ON) {
      // 取扱フラグ
      vo.handlingFlgIB = data.HandlingFlgIB;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceIB = data.ThisTimeSupplyPriceIB;
      // 仕入価格
      vo.thisTimeCostPriceIB = Number(data.ThisTimeCostPriceIB).toFixed(2);
      // 配達リード区分
      vo.deliveryLeadTimeTypeIB = data.DeliveryLeadTimeTypeIB;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameIB = data.DeliveryLeadTimeTypeNameIB;
      // いばらき　　プロモーションフラグ
      vo.promotionFlgIB = this.getDataValue(data.PromotionFlgIB);

      // プロモーションフラグ（いばらき）
      if (this.getDataValue(data.PromotionNo) != null && !PlessViewUtilsSub.isEmpty(this.getDataValue(data.PromotionNo))) {
        if (this.getDataValue(data.PromotionFlgIB) === this.FLAG_ON) {
          // セット企画数量
          vo.approvedNumIB = data.ApprovedNumIB;
          // 成立価格
          vo.approvedPriceIB = data.ApprovedPriceIB;
        }
      } else {
        // セット企画数量
        vo.approvedNumIB = this.INIT_APPROVED_NUM;
        // 成立価格
        vo.approvedPriceIB = data.ThisTimeSupplyPriceIB;
      }
    }

    // 取扱フラグ（とちぎ）
    if (data.HandlingFlgTO === this.FLAG_ON) {
      // 取扱フラグ
      vo.handlingFlgTO = data.HandlingFlgTO;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceTO = data.ThisTimeSupplyPriceTO;
      // 仕入価格
      vo.thisTimeCostPriceTO = Number(data.ThisTimeCostPriceTO).toFixed(2);
      // 配達リード区分
      vo.deliveryLeadTimeTypeTO = data.DeliveryLeadTimeTypeTO;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameTO = data.DeliveryLeadTimeTypeNameTO;
      // とちぎ　　プロモーションフラグ
      vo.promotionFlgTO = this.getDataValue(data.PromotionFlgTO);

      // プロモーションフラグ（とちぎ）
      if (this.getDataValue(data.PromotionNo) != null && !PlessViewUtilsSub.isEmpty(this.getDataValue(data.PromotionNo))) {
        if (this.getDataValue(data.PromotionFlgTO) === this.FLAG_ON) {
          // セット企画数量
          vo.approvedNumTO = data.ApprovedNumTO;
          // 成立価格
          vo.approvedPriceTO = data.ApprovedPriceTO;
        }
      } else {
        // セット企画数量
        vo.approvedNumTO = this.INIT_APPROVED_NUM;
        // 成立価格
        vo.approvedPriceTO = data.ThisTimeSupplyPriceTO;
      }
    }

    // 取扱フラグ（ぐんま）
    if (data.HandlingFlgGU === this.FLAG_ON) {
      // 取扱フラグ
      vo.handlingFlgGU = data.HandlingFlgGU;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceGU = data.ThisTimeSupplyPriceGU;
      // 仕入価格
      vo.thisTimeCostPriceGU = Number(data.ThisTimeCostPriceGU).toFixed(2);
      // 配達リード区分
      vo.deliveryLeadTimeTypeGU = data.DeliveryLeadTimeTypeGU;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameGU = data.DeliveryLeadTimeTypeNameGU;
      // ぐんま　　プロモーションフラグ
      vo.promotionFlgGU = this.getDataValue(data.PromotionFlgGU);

      // プロモーションフラグ（ぐんま）
      if (this.getDataValue(data.PromotionNo) != null && !PlessViewUtilsSub.isEmpty(this.getDataValue(data.PromotionNo))) {
        if (this.getDataValue(data.PromotionFlgGU) === this.FLAG_ON) {
          // セット企画数量
          vo.approvedNumGU = data.ApprovedNumGU;
          // 成立価格
          vo.approvedPriceGU = data.ApprovedPriceGU;
        }
      } else {
        // セット企画数量
        vo.approvedNumGU = this.INIT_APPROVED_NUM;
        // 成立価格
        vo.approvedPriceGU = data.ThisTimeSupplyPriceGU;
      }
    }

    // 取扱フラグ（ちば）
    if (data.HandlingFlgTI === this.FLAG_ON) {
      // 取扱フラグ
      vo.handlingFlgTI = data.HandlingFlgTI;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceTI = data.ThisTimeSupplyPriceTI;
      // 仕入価格
      vo.thisTimeCostPriceTI = Number(data.ThisTimeCostPriceTI).toFixed(2);
      // 配達リード区分
      vo.deliveryLeadTimeTypeTI = data.DeliveryLeadTimeTypeTI;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameTI = data.DeliveryLeadTimeTypeNameTI;
      // ちば　　　　プロモーションフラグ
      vo.promotionFlgTI = this.getDataValue(data.PromotionFlgTI);

      // プロモーションフラグ（ちば）
      if (this.getDataValue(data.PromotionNo) != null && !PlessViewUtilsSub.isEmpty(this.getDataValue(data.PromotionNo))) {
        if (this.getDataValue(data.PromotionFlgTI) === this.FLAG_ON) {
          // セット企画数量
          vo.approvedNumTI = data.ApprovedNumTI;
          // 成立価格
          vo.approvedPriceTI = data.ApprovedPriceTI;
        }
      } else {
        // セット企画数量
        vo.approvedNumTI = this.INIT_APPROVED_NUM;
        // 成立価格
        vo.approvedPriceTI = data.ThisTimeSupplyPriceTI;
      }
    }

    // 取扱フラグ（さいたま）
    if (data.HandlingFlgSA === this.FLAG_ON) {
      // 取扱フラグ
      vo.handlingFlgSA = data.HandlingFlgSA;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceSA = data.ThisTimeSupplyPriceSA;
      // 仕入価格
      vo.thisTimeCostPriceSA = Number(data.ThisTimeCostPriceSA).toFixed(2);
      // 配達リード区分
      vo.deliveryLeadTimeTypeSA = data.DeliveryLeadTimeTypeSA;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameSA = data.DeliveryLeadTimeTypeNameSA;
      // さいたま　　プロモーションフラグ
      vo.promotionFlgSA = this.getDataValue(data.PromotionFlgSA);

      // プロモーションフラグ（さいたま）
      if (this.getDataValue(data.PromotionNo) != null && !PlessViewUtilsSub.isEmpty(this.getDataValue(data.PromotionNo))) {
        if (this.getDataValue(data.PromotionFlgSA) === this.FLAG_ON) {
          // セット企画数量
          vo.approvedNumSA = data.ApprovedNumSA;
          // 成立価格
          vo.approvedPriceSA = data.ApprovedPriceSA;
        }
      } else {
        // セット企画数量
        vo.approvedNumSA = this.INIT_APPROVED_NUM;
        // 成立価格
        vo.approvedPriceSA = data.ThisTimeSupplyPriceSA;
      }
    }

    // 取扱フラグ（とうきょう）
    if (data.HandlingFlgTK === this.FLAG_ON) {
      // 取扱フラグ
      vo.handlingFlgTK = data.HandlingFlgTK;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceTK = data.ThisTimeSupplyPriceTK;
      // 仕入価格
      vo.thisTimeCostPriceTK = Number(data.ThisTimeCostPriceTK).toFixed(2);
      // 配達リード区分
      vo.deliveryLeadTimeTypeTK = data.DeliveryLeadTimeTypeTK;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameTK = data.DeliveryLeadTimeTypeNameTK;
      // とうきょう　　プロモーションフラグ
      vo.promotionFlgTK = this.getDataValue(data.PromotionFlgTK);

      // プロモーションフラグ（とうきょう）
      if (this.getDataValue(data.PromotionNo) != null && !PlessViewUtilsSub.isEmpty(this.getDataValue(data.PromotionNo))) {
        if (this.getDataValue(data.PromotionFlgTK) === this.FLAG_ON) {
          // セット企画数量
          vo.approvedNumTK = data.ApprovedNumTK;
          // 成立価格
          vo.approvedPriceTK = data.ApprovedPriceTK;
        }
      } else {
        // セット企画数量
        vo.approvedNumTK = this.INIT_APPROVED_NUM;
        // 成立価格
        vo.approvedPriceTK = data.ThisTimeSupplyPriceTK;
      }
    }

    // 取扱フラグ（ながの）
    if (data.HandlingFlgNA === this.FLAG_ON) {
      // 取扱フラグ
      vo.handlingFlgNA = data.HandlingFlgNA;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceNA = data.ThisTimeSupplyPriceNA;
      // 仕入価格
      vo.thisTimeCostPriceNA = Number(data.ThisTimeCostPriceNA).toFixed(2);
      // 配達リード区分
      vo.deliveryLeadTimeTypeNA = data.DeliveryLeadTimeTypeNA;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameNA = data.DeliveryLeadTimeTypeNameNA;
      // ながの　　　プロモーションフラグ
      vo.promotionFlgNA = this.getDataValue(data.PromotionFlgNA);

      // プロモーションフラグ（ながの）
      if (this.getDataValue(data.PromotionNo) != null && !PlessViewUtilsSub.isEmpty(this.getDataValue(data.PromotionNo))) {
        if (this.getDataValue(data.PromotionFlgNA) === this.FLAG_ON) {
          // セット企画数量
          vo.approvedNumNA = data.ApprovedNumNA;
          // 成立価格
          vo.approvedPriceNA = data.ApprovedPriceNA;
        }
      } else {
        // セット企画数量
        vo.approvedNumNA = this.INIT_APPROVED_NUM;
        // 成立価格
        vo.approvedPriceNA = data.ThisTimeSupplyPriceNA;
      }
    }

    // 取扱フラグ（にいがた）
    if (data.HandlingFlgNI === this.FLAG_ON) {
      // 取扱フラグ
      vo.handlingFlgNI = data.HandlingFlgNI;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceNI = data.ThisTimeSupplyPriceNI;
      // 仕入価格
      vo.thisTimeCostPriceNI = Number(data.ThisTimeCostPriceNI).toFixed(2);
      // 配達リード区分
      vo.deliveryLeadTimeTypeNI = data.DeliveryLeadTimeTypeNI;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameNI = data.DeliveryLeadTimeTypeNameNI;
      // にいがた　　　プロモーションフラグ
      vo.promotionFlgNI = this.getDataValue(data.PromotionFlgNI);

      // プロモーションフラグ（にいがた）
      if (this.getDataValue(data.PromotionNo) != null && !PlessViewUtilsSub.isEmpty(this.getDataValue(data.PromotionNo))) {
        if (this.getDataValue(data.PromotionFlgNI) === this.FLAG_ON) {
          // セット企画数量
          vo.approvedNumNI = data.ApprovedNumNI;
          // 成立価格
          vo.approvedPriceNI = data.ApprovedPriceNI;
        }
      } else {
        // セット企画数量
        vo.approvedNumNI = this.INIT_APPROVED_NUM;
        // 成立価格
        vo.approvedPriceNI = data.ThisTimeSupplyPriceNI;
      }
    }

    // 取扱フラグ（クルコ）
    if (data.HandlingFlgKU === this.FLAG_ON) {
      // 取扱フラグ
      vo.handlingFlgKU = data.HandlingFlgKU;
      // 供給価格（税込）
      vo.thisTimeSupplyPriceKU = data.ThisTimeSupplyPriceKU;
      // 仕入価格
      vo.thisTimeCostPriceKU = Number(data.ThisTimeCostPriceKU).toFixed(2);
      // 配達リード区分
      vo.deliveryLeadTimeTypeKU = data.DeliveryLeadTimeTypeKU;
      // 配達リード区分名称
      vo.deliveryLeadTimeTypeNameKU = data.DeliveryLeadTimeTypeNameKU;
      // クルコ　　　プロモーションフラグ
      vo.promotionFlgKU = this.getDataValue(data.PromotionFlgKU);

      // プロモーションフラグ（クルコ）
      if (this.getDataValue(data.PromotionNo) != null && !PlessViewUtilsSub.isEmpty(this.getDataValue(data.PromotionNo))) {
        if (this.getDataValue(data.PromotionFlgKU) === this.FLAG_ON) {
          // セット企画数量
          vo.approvedNumKU = data.ApprovedNumKU;
          // 成立価格
          vo.approvedPriceKU = data.ApprovedPriceKU;
        }
      } else {
        // セット企画数量
        vo.approvedNumKU = this.INIT_APPROVED_NUM;
        // 成立価格
        vo.approvedPriceKU = data.ThisTimeSupplyPriceKU;
      }
    }

    // 業態区分（デイリー）
    vo.dutiesFormDailyDiv = data.DutiesFormDailyDiv;
    // 業態区分（スポット）
    vo.dutiesFormSpotDiv = data.DutiesFormSpotDiv;

    return vo;
  }

  /**
   * サーバから取得した企画商品情報を反映する
   *
   * @param serverData サーバ取得データ
   */
  public updateSetPlanGoodsInfo(serverData: any): void {
    if (serverData === null) {
      return;
    }

    const blnAddFlg: boolean = <boolean>false;
    let planGoodsInfo: Array<any> = new Array<any>();

    if (isArray(serverData)) {
      planGoodsInfo = serverData;
    } else {
      planGoodsInfo.push(serverData);
    }

    for (const planGoodsData of planGoodsInfo) {
      this.promotionInfo = this.promotionInfo.concat(this.getSetPlanPromotionGoodsInfoVO(planGoodsData));

      // 排他ロック
      if (this.editLockBtn) {
        this.KYMW1312Component.LockUtilForPlanGoods('REGIST',
          this.orderCode,
          planGoodsData.MediumType,
          planGoodsData.PCode,
          (event: any) => {
            this.KYMW1312Component.lockScc_Handler(event); 
          },
          null,
          (event: any , result: any): void => {
            this.KYMW1312Component.lockErr_Handler({ event, result }); 
          },
          null,
          false);
      }
    }

    setTimeout(() => {
      this.KYMW1312Component.dtg_PromotionInfo.collectionView.sortDescriptions.clear();
      for (let i = 0; i < this.sortDirection.length; i++) {
        const sortDesc = this.sortDirection[i];
        this.KYMW1312Component.dtg_PromotionInfo.collectionView.sortDescriptions.push(
          new wjcCore.SortDescription(sortDesc.property, sortDesc.ascending)
        );
      }
    });
  }

  /**
   * null/配列を考慮してデータの値を取得する
   *
   * @private
   * @param {*} data
   * @returns {string}
   * @memberof KYMW1312Model
   */
  private getDataValue(data: any): string {
    let result: string = null;

    if (data == null) {
      result = null;
    } else if (isArray(data)) {
      if (PlessViewUtilsSub.isEmptyArray(data)) {
        result = null;
      } else {
        result = data;
      }
    } else {
      result = data;
    }

    return result;
  }
}
